module.exports = __webpack_public_path__ + "img/t3-c8.2c37a1aa.png";